"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const react_1 = __importDefault(require("react"));

const styles_1 = require("./styles");

const Dropdown_1 = __importDefault(require("../Icons/Dropdown"));

const Checkbox_1 = __importDefault(require("../Checkbox"));

const constants_1 = require("./constants");

const RadioButton_1 = __importDefault(require("../RadioButton"));

const hooks_1 = require("../../hooks");

const styled_components_1 = require("styled-components");

const List = props => {
  const {
    onClick,
    children
  } = props;
  const refDropdown = react_1.default.useRef(null);
  (0, hooks_1.useOutsideClick)(refDropdown, onClick);
  return (0, jsx_runtime_1.jsx)(styles_1.StyledListWrapper, Object.assign({
    count: children === null || children === void 0 ? void 0 : children.length
  }, {
    children: (0, jsx_runtime_1.jsx)(styles_1.StyledList, Object.assign({
      ref: refDropdown
    }, {
      children: children
    }), void 0)
  }), void 0);
};

const ListItem = props => {
  const {
    item,
    selectedOptions,
    onSelect,
    multiple
  } = props;
  return (0, jsx_runtime_1.jsx)(styles_1.StyledListItem, Object.assign({
    onClick: e => onSelect(e, item.value)
  }, {
    children: multiple ? (0, jsx_runtime_1.jsx)(Checkbox_1.default, {
      label: item.text,
      isChecked: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(i => i === item.value)
    }, void 0) : (0, jsx_runtime_1.jsx)(RadioButton_1.default, {
      label: item.text,
      isChecked: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(i => i === item.value)
    }, void 0)
  }), void 0);
};

const Dropdown = props => {
  const {
    disabled = false,
    label,
    onSelect,
    options = [],
    selectedOptions = [],
    multiple = false,
    labelColor = '#000000b3'
  } = props;
  const [isOpen, setIsOpen] = react_1.default.useState(false);
  const theme = (0, styled_components_1.useTheme)();

  const onClick = e => {
    e.preventDefault();

    if (disabled) {
      return;
    }

    setIsOpen(!isOpen);
  };

  const onSelected = (e, selectedOption) => {
    e.preventDefault();

    if (multiple) {
      if (selectedOptions.includes(selectedOption)) {
        onSelect(selectedOptions.filter(option => option !== selectedOption));
      } else {
        onSelect([...selectedOptions, selectedOption]);
      }
    } else {
      onSelect([selectedOption]);
      onClick(e);
    }
  };

  const title = selectedOptions.length > 0 && options.length > 0 ? options.filter(item => selectedOptions.includes(item.value)).map(item => item.text).join(', ') : constants_1.DROPDOWN_DEFAULT_TITLE;
  return (0, jsx_runtime_1.jsxs)(styles_1.Container, {
    children: [label && (0, jsx_runtime_1.jsx)(styles_1.Label, Object.assign({
      isMedium: !!theme.isMobile,
      fontSize: theme.isMobile ? '18px' : '14px',
      fontColor: labelColor
    }, {
      children: label
    }), void 0), (0, jsx_runtime_1.jsxs)(styles_1.Header, Object.assign({
      onClick: onClick,
      disabled: disabled,
      isOpen: isOpen
    }, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.Title, Object.assign({
        title: title,
        disabled: disabled
      }, {
        children: title
      }), void 0), (0, jsx_runtime_1.jsx)(styles_1.Arrow, Object.assign({
        isOpen: isOpen
      }, {
        children: (0, jsx_runtime_1.jsx)(Dropdown_1.default, {}, void 0)
      }), void 0)]
    }), void 0), isOpen && options.length > 0 && (0, jsx_runtime_1.jsx)(List, Object.assign({
      onClick: onClick
    }, {
      children: options.map((item, index) => (0, jsx_runtime_1.jsx)(ListItem, {
        onSelect: onSelected,
        selectedOptions: selectedOptions,
        item: item,
        multiple: multiple
      }, `${item.value}-${index}`))
    }), void 0)]
  }, void 0);
};

Dropdown.defaultProps = {
  disabled: false,
  multiple: false,
  label: '',
  options: [],
  selectedOptions: [],
  onSelect: () => {}
};
exports.default = Dropdown;